import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useContext, useState, useEffect } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import CityGroup from './city-group';
import CityList from './city-list';
import grouping from './utils/grouping';

var CityPanel = function CityPanel(_ref) {
  var _context, _context2;

  var groups = _ref.groups,
      commons = _ref.commons,
      cityList = _ref.cityList,
      onSelect = _ref.onSelect;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      globalLocale = _useContext.locale;

  var cityPickerLang = globalLocale.getCompLangMsg({
    componentName: 'CityPicker'
  });

  var _useState = useState('domestic'),
      _useState2 = _slicedToArray(_useState, 2),
      activedIndex = _useState2[0],
      setActivedIndex = _useState2[1];

  var _useState3 = useState({
    domestic: [],
    foreign: []
  }),
      _useState4 = _slicedToArray(_useState3, 2),
      cityGroups = _useState4[0],
      setCityGroups = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      groupKeys = _useState6[0],
      setGroupKeys = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      activedGroupIndex = _useState8[0],
      setActivedGroupIndex = _useState8[1];

  var _useState9 = useState([commons ? commons.domestic : []]),
      _useState10 = _slicedToArray(_useState9, 2),
      list = _useState10[0],
      setList = _useState10[1];

  useEffect(function () {
    if (!groups) {
      return;
    }

    var domestic = groups.domestic,
        foreign = groups.foreign;
    domestic = grouping(domestic);
    foreign = grouping(foreign);

    if (commons === null || commons === void 0 ? void 0 : commons.domestic) {
      domestic.unshift(cityPickerLang.common);
    }

    if (commons === null || commons === void 0 ? void 0 : commons.foreign) {
      foreign.unshift(cityPickerLang.common);
    }

    setCityGroups({
      domestic: domestic,
      foreign: foreign
    });
  }, [groups, commons]);
  useEffect(function () {
    if (commons) {
      setList([commons[activedIndex]]);
    } else {
      var _groups = cityGroups[activedIndex];
      var currentGroup = _groups[0];
      var currentGroups = (currentGroup || '').split('');
      var newList = [];
      var currentList = cityList[activedIndex];
      currentGroups.forEach(function (character) {
        var temp = currentList[character] ? currentList[character] : [];
        newList.push(temp);
      });
      setList(newList);
      setGroupKeys(currentGroups);
    }

    setActivedGroupIndex(0);
  }, [activedIndex, cityGroups, groups, cityList]);
  var cityPickerPrefixCls = getPrefixCls(prefixCls, 'city-picker');
  var containerCls = classNames("".concat(cityPickerPrefixCls, "-panel-container"));
  var headerCls = classNames("".concat(cityPickerPrefixCls, "-header"));
  var contentContainerCls = classNames("".concat(cityPickerPrefixCls, "-content-container"));
  var domesticCls = classNames(_concatInstanceProperty(_context = "".concat(cityPickerPrefixCls, "-tab-item ")).call(_context, cityPickerPrefixCls, "-header-domestic"), {
    active: activedIndex === 'domestic'
  });
  var internationalCls = classNames(_concatInstanceProperty(_context2 = "".concat(cityPickerPrefixCls, "-tab-item ")).call(_context2, cityPickerPrefixCls, "-header-internation"), {
    active: activedIndex === 'foreign'
  });

  var handleDomesticClick = function handleDomesticClick() {
    if (activedIndex === 'domestic') return;
    setActivedIndex('domestic');
  };

  var handleInternationClick = function handleInternationClick() {
    if (activedIndex === 'foreign') return;
    setActivedIndex('foreign');
  };
  /**
   * 分组变换事件
   * @param index 分组索引
   */


  var handleGroupChange = function handleGroupChange(index) {
    if (!cityList) {
      return;
    }

    var groups = cityGroups[activedIndex];
    var currentGroup = groups[index];

    if (commons && currentGroup === cityPickerLang.common) {
      setList([commons[activedIndex] || []]);
      setGroupKeys(null);
      return;
    }

    var currentGroups = (currentGroup || '').split('');
    var newList = [];
    var currentList = cityList[activedIndex];
    currentGroups.forEach(function (character) {
      var temp = currentList[character] ? currentList[character] : [];
      newList.push(temp);
    });
    setList(newList);
    setGroupKeys(currentGroups);
    setActivedGroupIndex(index);
  };

  var handleSelectCity = function handleSelectCity(city) {
    onSelect === null || onSelect === void 0 ? void 0 : onSelect(city);
  };

  var isClassified = commons && commons.domestic && commons.foreign;
  return /*#__PURE__*/React.createElement("div", {
    className: containerCls
  }, isClassified && /*#__PURE__*/React.createElement("div", {
    className: headerCls
  }, /*#__PURE__*/React.createElement("div", {
    className: domesticCls,
    onClick: handleDomesticClick
  }, cityPickerLang.domestic), /*#__PURE__*/React.createElement("div", {
    className: internationalCls,
    onClick: handleInternationClick
  }, cityPickerLang.internation)), /*#__PURE__*/React.createElement("div", {
    className: contentContainerCls
  }, /*#__PURE__*/React.createElement(CityGroup, {
    groups: cityGroups[activedIndex],
    activedIndex: activedGroupIndex,
    changeIndex: handleGroupChange
  }), /*#__PURE__*/React.createElement(CityList, {
    groupKeys: groupKeys,
    cityList: list,
    onSelect: handleSelectCity
  })));
};

export default CityPanel;